import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useSaveUserProfile = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("UserProfile/SaveUserProfile", formData);
  });
  return mutation;
};
export default useSaveUserProfile;
